import {lazy} from "react"

export default [
    {
        path:"/chat/:jenis",
        component:lazy(()=>import("../../views/chats/Chats"))
        
    }
]